import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// Busca en public/index.html el <div id="root"></div>
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
